export default __webpack_public_path__ + "static/media/shlomo-karaei.5ed282d0.png";